export default __webpack_public_path__ + "static/media/dancing.8d6cfb70.png";